import { translate } from "app/language/service"
import { getFormattedFileSize, uploadFile } from "app/tools/file"
import { ICreativeUploadData, IMedia, IMediaUploadParams, MAX_MEDIA_FILE_UPLOAD_SIZE_IN_BYTES } from "media/model"
import { mediaRPO } from "media/repository"
import { state } from "media/state"
import { messageSVC } from "message/service"
import { createCampaignMedia } from "./common"

export function getDefaultCreativeUploadState(): ICreativeUploadData {
  return {
    selectedFiles: null,
    error: "",
    isUploading: false,
    progressPercent: 0
  }
}

export function isCreativeUploadFileValid(files: FileList | null): boolean {
  if (files && files.length > 0) {
    const file = files[0]
    if (file.size > MAX_MEDIA_FILE_UPLOAD_SIZE_IN_BYTES) {
      messageSVC.error(
        translate("upload.error.size", [
          getFormattedFileSize(file.size),
          getFormattedFileSize(MAX_MEDIA_FILE_UPLOAD_SIZE_IN_BYTES)
        ])
      )
      return false
    }
  }
  return true
}

export function uploadMediaCreative(
  params: IMediaUploadParams,
  { error, selectedFiles, isUploading }: ICreativeUploadData,
  setData: (newData: Partial<ICreativeUploadData>) => void
): Promise<IMedia> {
  return new Promise<IMedia>(async (resolve, reject) => {
    if (error) {
      messageSVC.error(translate("upload.error.file.error"))
      return reject("We are currently uploading a creative")
    }
    if (isUploading) {
      messageSVC.error(translate("upload.error.is.uploading"))
      return reject("We are currently uploading a creative")
    }
    if (!selectedFiles || selectedFiles.length === 0) {
      messageSVC.error(translate("upload.error.no.file.selected"))
      return reject("No file is selected")
    }
    const file = selectedFiles[0]
    setData({ isUploading: true, error: "" })
    try {
      const media = await createCampaignMedia({
        mediaName: file.name,
        ...params
      })
      const response = await uploadFile(mediaRPO.getMediaCreativeUploadUrl(media.id), file, uploadParams => {
        clearTimeout(state.creativeUploadRefreshTimeout)
        state.creativeUploadRefreshTimeout = setTimeout(() => {
          const progressPercent = (100 * uploadParams.loadedBytes) / uploadParams.totalBytes
          setData({ progressPercent })
        }, 300)
      })
      const creative = response.data
      media.creatives.push(creative)
      resolve(media)
    } catch (err) {
      clearTimeout(state.creativeUploadRefreshTimeout)
      console.error(err)
      setData({
        isUploading: false,
        error: translate("upload.error.serveur.request")
      })
      reject("Unable to upload creative, server error")
    }
  })
}
